import { createSlice } from "@reduxjs/toolkit";
import PickSummary from "../PickDetail/PickSummary";

const roundToJoinSlice = createSlice({
  name: "roundToJoin",
  initialState: {
    loading: false,
    error: false,
    matchWeeks: "",
    redeemPopup: false,
    pickRemains: 2,
    fixturePopupOpen: false,
    potTokenValue: 0,
    pageCategory: "Round To Join",
    roundToJoinPotData: [],
    v2Fixtures: [],
    myRound: [],
    selectedPot: "",
    componentType: "",
    selectectTimeType: "",
    leagueId: "",
    choosePickDetail: {
      pickId: "",
      matchWeekId: "",
      potId: "",
      label: ""
    },
    pickDetailMatchWeek: "",
  },
  reducers: {
    updateLeagueId: (state, action) => {
      state.leagueId = action.payload;
    },
    updatePickMAtchWeek: (state, action) => {
      state.pickDetailMatchWeek = action.payload;
    },
    updateLoadingStatus: (state, payload) => {
      state.loading = true;
    },
    updateErrStatus: (state, payload) => {
      state.loading = false;
      state.error = true;
    },
    updateMyRound: (state, action) => {
      state.myRound = action.payload;
    },
    fetchRoundToJoinData: (state, payload) => {
      const { roundToJoinPot } = payload.payload;
      state.loading = false;
      state.roundToJoinPotData = roundToJoinPot;
    },
    updateRedeemPopup: (state, payload) => {
      state.redeemPopup = payload.payload;
    },
    updatePickRemains: (state, payload) => {
      state.pickRemains = payload.payload;
    },
    updatePotTokenValue: (state, payload) => {
      state.potTokenValue = payload.payload;
    },
    fetchRoundPageCategory: (state, payload) => {
      state.loading = false;
      state.pageCategory = payload.payload;
    },
    updateV2Fixtures: (state, payload) => {
      state.loading = false;
      state.v2Fixtures = payload.payload.data || payload.payload;
    },
    updateMatchWeeks: (state, payload) => {
      state.loading = false;
      state.matchWeeks = payload.payload;
    },
    updateSelectedPot: (state, payload) => {
      state.loading = false;
      state.selectedPot = payload.payload;
    },

    // update fixtures changes

    fixtureOpen: (state, action) => {
      state.loading = true;
      state.fixturePopupOpen = action.payload;
    },
    updateSelectedFixtures: (state, action) => {
      state.loading = false;
      state.error = false;

      state.v2Fixtures = state.v2Fixtures.map((fixture) => ({
        ...fixture,
        selected:
          fixture.id === action.payload.id ? action.payload.selected : false,
      }));
    },
    updateFixtureSelectedComponent: (state, action) => {
      state.componentType = action.payload.component;
      state.selectectTimeType = action.payload.type;
      state.choosePickDetail = {
        pickId: action.payload.pickId,
        matchWeekId: action.payload.matchWeekId,
        potId: action.payload.potId,
        label: action.payload.label
      };
    },
    // updateRoundToJoinSocket: (state, action) => {
    //   const { id, active_picks_count, net_pot_value, status } = action.payload;
    //   const oldRoundToJoin = JSON.parse(
    //     JSON.stringify(state.roundToJoinPotData)
    //   );

    //   const oldMyRound = JSON.parse(JSON.stringify(state.myRound));
    //   state.roundToJoinPotData = oldRoundToJoin.map((round) => {
    //     return {
    //       ...round,
    //       pots: round.pots.map((pot) => {
    //         console.log(oldRoundToJoin, round);
    //         if (pot.id === id) {
    //           return { ...pot, active_picks_count, net_pot_value, status };
    //         } else {
    //           return pot;
    //         }
    //       }),
    //     };
    //   });
    //   state.myRound = oldMyRound.map((round) => {
    //     if (round.id === id) {
    //       return { ...round, active_picks_count, net_pot_value, status };
    //     } else {
    //       return round;
    //     }
    //   });
    // },

    updateRoundToJoinSocket: (state, action) => {
      const {
        id,
        active_picks_count,
        net_pot_value,
        status,
        configured_league_id,
        lost_picks,
        pot_amount_percentage,
      } = action.payload;

      state.roundToJoinPotData.forEach((round) => {
        round.pots.forEach((leaguePot) => {
          if (String(leaguePot.league_id) === String(configured_league_id)) {
            if (String(leaguePot.id) === String(id)) {
              leaguePot.active_picks_count = active_picks_count;
              leaguePot.net_pot_value = net_pot_value;
              leaguePot.status = status;
              leaguePot.lost_picks = lost_picks;
              leaguePot.pot_value_percentage = pot_amount_percentage;
            }
          }
        });
      });

      // Update myRound
      state.myRound.forEach((round) => {
        if (String(round.id) === String(id)) {
          round.active_picks_count = active_picks_count;
          round.net_pot_value = net_pot_value;
          round.status = status;
          round.lost_picks = lost_picks;
          round.pot_value_percentage = pot_amount_percentage;
        }
      });
    },
  },
});

export const {
  updateLeagueId,
  updatePickMAtchWeek,
  fetchRoundPageCategory,
  updateLoadingStatus,
  updateMyRound,
  updateErrStatus,
  fetchRoundToJoinData,
  updateV2Fixtures,
  updateMatchWeeks,
  updateRedeemPopup,
  updatePotTokenValue,
  updateSelectedPot,
  fixtureOpen,
  updateSelectedFixtures,
  updateFixtureSelectedComponent,
  updatePickRemains,
  updateRoundToJoinSocket,
} = roundToJoinSlice.actions;
export default roundToJoinSlice.reducer;
